import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import AllBuyProducts from "./AllBuyProducts/AllBuyProducts";
import FilterAll from "../FilterAll/FilterAll";
import { useDispatch, useSelector } from "react-redux";
import { getFilter } from "../../../../redux/filter/action";
import OTSSearch from "../../../Common/Search/OTSSearch";
import classnames from "classnames";
import { Nav, NavItem, NavLink } from "reactstrap";
import { useAllFilterBaseContext } from "../../../../Context/AllFilterBaseContext";
import { FilterSaleListings } from "../../../../redux/sale/action";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import { useNavigate } from "react-router-dom";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { getPostStingName } from "../../../../assests/extention/commonfunction";

export default function SearchBuyProducts() {
  const {
    state,
    setSearch,
    setProposed,
    setViewed,
    setWishlist,
    setListNull,
    setRerender,
    setAllpostfiltertab,
  } = useAllFilterBaseContext();
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const dispatch = useDispatch();
  const { pageNumber } = state;
  const size = 15;

  const [activeTab, setActiveTab] = useState(
    "allpost" || state?.allpostfiltertab
  );

  const data = {
    method: "GET",
    index: pageNumber,
    size: size,
    search: state?.search,
    proposed: state.proposed,
    viewed: state.viewed,
    wishlist: state.wishlist,
    filter: [
      {
        id: "50",
        title: "Category",
        filter_type: "5",
        values: state?.keywords,
      },
      {
        id: "25",
        title: "Industry",
        filter_type: "5",
        values: state?.industries,
      },
      {
        id: "53",
        title: "Sub Category",
        filter_type: "5",
        values: state?.subcategories,
      },
      {
        id: "24",
        title: "sort by",
        filter_type: "2",
        values: state?.sortByTime,
      },
      {
        id: "26",
        min: state.minHourlyRate,
        max: state.maxHourlyRate,
      },
      {
        id: "23",
        title: "Country",
        values: state?.countries,
      },
      {
        id: "26",
        title: "Price range",
        min: state.minHourlyRate,
        max: state.maxHourlyRate,
        filter_type: "7",
      },
    ],
  };

  useEffect(() => {
    dispatch(getFilter(4));
  }, []);

  useEffect(() => {
    if (state?.allpostfiltertab) {
      setActiveTab(state?.allpostfiltertab);
    } else {
      setActiveTab("allpost");
    }
  }, [state?.allpostfiltertab]);

  useEffect(() => {
    dispatch(FilterSaleListings(data));
    window.scrollTo({
      top: 600,
      behavior: "smooth",
    });
  }, [state]);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setAllpostfiltertab(tab);
      setRerender();

      switch (tab) {
        case "allpost":
          setListNull();
          break;
        case "recentview":
          setViewed();
          break;
        case "savepost":
          setWishlist();
          break;
        case "appliedpost":
          setProposed();
          break;
        default:
          break;
      }
    }
  };

  const getallsale = useSelector(
    ({ sale: { getfilterdsale } }) => getfilterdsale
  );

  const { setOTSroute } = useRouteBaseStateContext();
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");

  return (
    <div className="project-section searchbuy">
      <div className="col-md-12 project1">
        <div className="col-md-6 mx-auto">
          <h2 className="font-42">
            Discover High Quality Explore Our Exclusive Product Range.
          </h2>
          <OTSSearch
            state={state}
            setSearch={setSearch}
            placeholder={`Search ${getPostStingName("5")}`}
          />
        </div>
        <p>Have a product for Buy & Sell? Let’s get it listed</p>
        <button
          onClick={() => { navigate(`/${lan}/dashboard/myotsproducts`); setOTSroute('ProductforSell'); }}
          className="btn post-btn"
        >
          Add a Product
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/project/plus.svg`}
            alt=""
          />
        </button>
      </div>
      <div className="col-lg-10 mx-auto tab-sec packaged-tab">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "allpost" })}
              onClick={() => {
                toggle("allpost");
              }}
            >
              All ({getallsale?.count?.count || 0})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "recentview" })}
              onClick={() => {
                toggle("recentview");
              }}
            >
              Recently viewed ({getallsale?.count?.viewed_count || 0})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "savepost" })}
              onClick={() => {
                toggle("savepost");
              }}
            >
              Saved Products ({getallsale?.count?.wishlist_count || 0})
            </NavLink>
          </NavItem>
        </Nav>
        <div className="row">
          <div className="col-lg-3 col-md-4">
            <FilterAll />
          </div>
          <AllBuyProducts activeTab={activeTab} />
        </div>
      </div>
    </div>
  );
}
